export default "__VITE_ASSET__IwugMxv___"